import moment from 'moment-timezone'

moment.locale(window.navigator.userLanguage || window.navigator.language)
const localeData = moment.localeData()

function directive() {
  return {
    require: '^ngModel',
    restrict: 'A',
    replace: false,
    link: function (scope, elem, attrs, ngModelController) {
      const timezone = window.org_settings.timezone || moment.tz.guess()
      const dateFormat = localeData.longDateFormat(
        attrs.momentDateFormatter || 'LLL'
      )
      ngModelController.$formatters.push((data) => {
        if (!data) {
          return ''
        }
        return moment(data).tz(timezone).format(dateFormat)
      })
    },
  }
}

export default [directive]
